<template>
    <div class="com-item summary-module" :key="index">
        <div class="component person-nav">
            <div
                class="van-sticky"
                :style="{
                    backgroundColor: (modata.WContent.bgColor || 'transparent'),
                    backgroundImage: modata.WContent.bgImg ? 'url(' + modata.WContent.bgImg + ')' : 'none',
                    color: modata.WContent.textColor || '#333'
                }"
            >
                <div class="summary-module__inner" v-if="modata.WContent.type1 || modata.WContent.type2">
                    <template v-if="modata.WContent.showType == 1">
                        <div class="summary-module__head">
                            <p class="summary-module__en">{{ modata.WContent.type1 && modata.WContent.type1.enTitle }}</p>
                            <p class="summary-module__cn">{{ modata.WContent.type1 && modata.WContent.type1.cnTitle }}</p>
                        </div>
                        <div
                            class="summary-module__list summary-module__list--3"
                            v-if="modata.WContent.type1 && modata.WContent.type1.items && modata.WContent.type1.items.length"
                        >
                            <div v-for="(item, idx) in modata.WContent.type1.items" :key="idx" class="summary-module__card">
                                <div class="summary-module__card-content">
                                    <div class="summary-module__card-icon">
                                        <img v-if="item.imgUrl" :src="item.imgUrl" alt="" />
                                    </div>
                                    <p class="summary-module__card-title">{{ item.title }}</p>
                                    <div class="summary-module__card-desc ql-editor">{{ item.textHtml }}</div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <div class="summary-module__head">
                            <p class="summary-module__en">{{ modata.WContent.type2 && modata.WContent.type2.enTitle }}</p>
                            <p class="summary-module__cn">{{ modata.WContent.type2 && modata.WContent.type2.cnTitle }}</p>
                        </div>
                        <div
                            class="summary-module__list summary-module__list--6"
                            v-if="modata.WContent.type2 && modata.WContent.type2.items && modata.WContent.type2.items.length"
                        >
                            <div v-for="(item, idx) in modata.WContent.type2.items" :key="idx" class="summary-module__card">
                                <div class="summary-module__card-content">
                                    <div class="summary-module__card-icon">
                                        <img v-if="item.imgUrl" :src="item.imgUrl" alt="" />
                                    </div>
                                    <p class="summary-module__card-label">{{ item.label }}</p>
                                    <p class="summary-module__card-desc">{{ item.content }}</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "summary-module",
    components: {},
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'summary',
                    Title: '总览卡片',
                    MID: 17,
                    WID: null,
                    ModuleName: 'summary-module',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {}
    },
    mounted() {},
    beforeDestroy() {},
    methods: {},
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.van-sticky {
    min-height: 5.55556rem;
    background-fill-value: background-image;
    background-attachment: fixed;
    background_radio: 2;
}

.summary-module {
    .summary-module__inner {
        width: 90%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 4% 0 5%;
        box-sizing: border-box;
    }
    .summary-module__head {
        margin-bottom: 32px;
    }
    .summary-module__en {
        font-size: 20px;
        font-family: "PingFang Medium", "pingfang medium", sans-serif;
        text-align: center;
        color: #014fa4;
        margin: 0 0 8px 0;
        opacity: 1;
    }
    .summary-module__cn {
        font-size: 42px;
        font-family: "PingFang Heavy", "pingfang heavy", sans-serif;
        text-align: center;
        font-weight: normal;
        margin: 0 0 28px 0;
        line-height: 1.2;
    }
    .summary-module__list {
        display: flex;
        flex-wrap: wrap;
    }
    .summary-module__list--3 {
    }
    .summary-module__list--3 .summary-module__card {
        flex: 0 0 calc(100% / 3 - 14px);
        width: 92%;
        margin: 0 auto;

       

        .summary-module__card-content {
            padding: 12% 8%;
            background: #fff;
            border-radius: 10px;
            transition: all 0.5s;
            text-align: left;
            box-sizing: border-box;
            &:hover {
                transform: translateY(-10px);
                background: #004ea2;
                .summary-module__card-title { color: #fff; }
                .summary-module__card-desc { color: #fff; }
                .summary-module__card-icon { filter: brightness(0) invert(1); }
            }
        }
    }
    .summary-module__list--3 .summary-module__card-icon {
        width: 60px;
        height: 60px;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        img { max-width: 100%; max-height: 100%; }
    }
    .summary-module__list--3 .summary-module__card-title {
        font-size: 24px;
        font-family: "PingFang Heavy", "pingfang heavy", sans-serif;
        font-weight: normal;
        margin: 6% 0 4% 0;
        line-height: 1.3;
    }
    .summary-module__list--3 .summary-module__card-desc {
        min-height: 130px;
        font-size: 14px;
        line-height: 1.6;
        color: #333;
        text-align: left;
        opacity: 1;
        white-space: pre-wrap;

        p { margin: 0 0 4px 0; }
    }

    .summary-module__list--6 {
        margin-top: 24px;
    }
    .summary-module__list--6 .summary-module__card {
        flex: 0 0 calc(100% / 6);
        flex-grow: 0;
        flex-shrink: 0;
        transition: all 0.5s;
    }
    .summary-module__list--6 .summary-module__card:hover{
      transform: translate(0, -15px);
    }


    .summary-module__list--6 .summary-module__card-content {
        width: 92%;
        margin: 0 auto;
        padding: 3vw 2vw;
        background: #fff;
        box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.15);
        border-radius: 10px;
        height: 100%;
        text-align: center;
        box-sizing: border-box;
    }

    .summary-module__list--6 .summary-module__card-icon {
        height: auto;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;

        img { width: 90px; max-width: 100%; height: auto; }
    }
    .summary-module__list--6 .summary-module__card-label {
        font-size: 21px;
        font-family: "PingFang Heavy", "pingfang heavy", sans-serif;
        font-weight: normal;
        margin: 20px 0 8px 0;
        line-height: 1.3;
    }
    .summary-module__list--6 .summary-module__card-desc {
        font-size: 14px;
        color: #525252;
        line-height: 1.5;
        margin: 0;
        opacity: 1;
        white-space: pre-wrap;
    }
}

@media screen and (max-width: 768px) {
   .summary-module{
    .summary-module__list{
        flex-direction: column;
    }

    .summary-module__list--3{
        .summary-module__card{
            margin-bottom:20px;
        }
      .summary-module__card-desc{
        font-size: 18px;
        min-height: 0;
      }
    }

 
   }


}


</style>
